

import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";

 
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCrKbVdiuH4of3DShtjvoCCWJDxCgENRjw",
  authDomain: "loverclass.firebaseapp.com",
  projectId: "loverclass",
  storageBucket: "loverclass.appspot.com",
  messagingSenderId: "1074786958852",
  appId: "1:1074786958852:web:76211beb8d69dd9e3e3f51",
  measurementId: "G-JD9NXG7H4D"
};
 
const secondaryApp = initializeApp(firebaseConfig);

const analytics = getAnalytics(secondaryApp);
// const database = getDatabase(app);
// const auth = getAuth(app);
// const storage = getStorage(app);
const firestore = getFirestore(secondaryApp);

export  {secondaryApp,analytics,firestore};
  
